<template>
  <v-container class="tradingMentor-view" fluid>
    <h1 class="text-center my-5">{{ $t("title_MentorIndex") }}</h1>
    <v-row v-blur="blurConfig" align="center" justify="center">
      <p class="mr-3 mt-n1">{{ $t("subtitlePrepend") }}</p>
      <SwisetSelect
        ref="Accounts"
        class="mentor-swiset"
        :label="$t('label_MentorIndex')"
        :placeholder="$t('label_MentorIndex')"
        :options="
          brokerAccounts.map((acc) => ({
            value: Number(acc.id),
            text: `${acc.identifier} ~ ${acc.broker.name}`,
          }))
        "
        v-model="brokerAccountSelected"
        :changeEvent="accountChanged"
        :type="0"
        :allOption="true"
      >
      </SwisetSelect>
      <p class="ml-3 mt-n1">
        {{ $tc("subtitleAppend", brokerAccountSelected === undefined ? 2 : 1) }}
      </p>
    </v-row>
    <v-row
      v-blur="blurConfig"
      v-if="brokerAccountSelected !== undefined"
      align="center"
      justify="center"
    >
      <p class="my-0 mr-3">{{ $t("tradingPlan.prepend") }}</p>
      <v-btn class="button-plan" @click="openTradingPlan"
        >{{ $t("tradingPlan.btnTradingPlan") }}
        <v-icon class="ml-2" color="white" small>fa-swatchbook</v-icon></v-btn
      >
    </v-row>
    <InsightsSummary
      v-blur="blurConfig"
      :insights="selectedInsights"
      :full="true"
    />
    <LargeCardAd v-if="ad !== null" :ad="ad" />

    <!-- Overlay for CTA upgrade to pro !-->
    <v-overlay :dark="false" v-model="canSeeInsights" absolute opacity="0">
      <UpgradeToPro
        :message="messageUpgradeToPro"
        @closeWindow="seeProAdvantages = false"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from "../../ads/adEngine";

import Repository from "../../repositories/insights";
import InsightsSummary from "@/views/Mentor/components/InsightsSummary";
import UpgradeToPro from "@/components/UpgradeToPro";
import LargeCardAd from "@/ads/LargeCardAd";
import SwisetSelect from "../../components/comp-base/SwisetSelect.vue";
export default {
  name: "MentorIndex",
  components: { LargeCardAd, UpgradeToPro, InsightsSummary, SwisetSelect },
  data() {
    return {
      // Ads
      ad: null,

      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear",
      },
      canSeeInsights: !this.$store.state.user.isPro,
      messageUpgradeToPro: this.$t("ctaUpgradeToPro"),

      brokerAccounts: [],
      brokerAccountSelected: undefined,
      allInsights: [],
      selectedInsights: [],

      overlayTradingPlan: false,
    };
  },

  async mounted() {
    await this.init();
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd("Large Ad");
    },
    async init() {
      this.retrieveAd();
      let refs = this.$refs;
      const store = this.$store;
      await Repository.getUserInsights()
        .then((response) => {
          if (response.status < 400) {
            this.allInsights = [];
            response.data.forEach((insight) => {
              this.allInsights.push(JSON.parse(insight));
            });
            this.updateBrokerAccounts();
          }
        })
        .then(function () {
          let accSelect = refs.Accounts.$el;
          accSelect.querySelectorAll(".option").forEach(function (el, index) {
            if (index > 1) {
              let identifier = el.textContent.split("~")[0];
              let isVerified = store.state.user.brokerAccounts.find(
                (b) => b.identifier.trim() === identifier.trim()
              ).verified;
              if (isVerified) {
                let icon = document.createElement("img");
                icon.src = require("@/assets/icons/Audited.svg");
                icon.alt = "Audited Icon";
                icon.style.position = "absolute";
                icon.style.width = "16px";
                icon.style.height = "16px";
                icon.style.right = 0;
                el.appendChild(icon);
              }
            }
          });
        });
    },
    accountChanged() {
      if (this.brokerAccountSelected === undefined)
        this.selectedInsights = this.allInsights.find(
          (insightsData) => insightsData.id === -1
        );
      else
        this.selectedInsights = this.allInsights.find(
          (insightsData) =>
            insightsData.id === Number(this.brokerAccountSelected)
        );
    },
    updateBrokerAccounts() {
      let accountsIds = [];
      if (this.allInsights.length > 0) {
        this.selectedInsights = this.allInsights[this.allInsights.length - 1];
        accountsIds = this.allInsights.map((object) => {
          return object["id"];
        });
        accountsIds.forEach((id) => {
          let accountFound = this.$store.state.user.brokerAccounts.find(
            (account) => account.id === id
          );
          if (accountFound !== undefined)
            this.brokerAccounts.push(accountFound);
        });
      }
      this.brokerAccountSelected = undefined;
    },
    openTradingPlan() {
      this.$router.push("/plan");
    },
  },
};
</script>



<style lang="scss">
.mentor-swiset {
  width: 280px;
  flex-grow: 0;
  margin-bottom: 20px;

  .v-icon {
    position: absolute;
    right: 0;
  }
}
</style>
